import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)

export default new Factory(resource)
